import * as React from "react";
import Header from "./common/Header"

interface IProps
{
    children: React.ReactNode;
    baseUrl: string;
    databaseUrl: string;
    oldDatabaseUrl: string
}
class App extends React.Component<IProps> {

    public render() {
        return (
            <div className="container-fluid">
                <Header baseUrl={this.props.baseUrl} databaseUrl={this.props.databaseUrl} oldDatabaseUrl={this.props.oldDatabaseUrl} />
                {this.props.children}
            </div>
        );
    }
}


export default App